import './App.css'
import Home from './Views/Home'
import { createContext, useState, useMemo } from 'react'
import './App.css'
import { Link, Route, Routes } from 'react-router-dom'
import TermSelectForm from './components/TermSelectForm/TermSelectForm'
import ReimbursementSelector from './components/ReimbursementSelector/ReimbursementSelector'
import ReviewComponent from './components/ReviewComponent/ReviewComponent'
import FinalCardComponent from './components/FinalCardComponent/FinalCardComponent'
import NoMatch from './components/NoMatch/NoMatch'
import StatusCard from './components/UrlCard/StatusCard'
import FileCard from './components/ReimbursementSelector/FileCard'
import { MainContext } from './components/MainContext'
import { useNavigate } from 'react-router-dom'
import FeedBacksForm from './components/FeedbacksForm'
import About from './components/About'

function App() {
  const navigate = useNavigate()
  const version = process.env.REACT_APP_VERSION
  const [user, setUser] = useState({})
  const [selectedTerm, setSelectedTerm] = useState({})
  const [reimbursement, setReimbursement] = useState({})
  const [reimbursementItem, setReimbursementItem] = useState({})
  const [receiptFile, setReceiptFile] = useState({})
  const value = useMemo(
    () => ({
      user,
      setUser,
      selectedTerm,
      setSelectedTerm,
      reimbursement,
      setReimbursement,
      reimbursementItem,
      setReimbursementItem,
      receiptFile,
      setReceiptFile,
    }),
    [user, selectedTerm, reimbursement, reimbursementItem, receiptFile],
  )

  return (
    <div className="App text-slate-300 m-auto max-w-lg flex flex-col min-h-screen overflow-hidden">
      <main className="flex-grow center">
        <MainContext.Provider value={value}>
          <Routes>
            <Route exact path="/" element={<Home />}></Route>
            <Route path="/SelectTerm" element={<TermSelectForm />}></Route>
            <Route
              path="/Reimbursement"
              element={<ReimbursementSelector />}
            ></Route>
            <Route path="/FileUpload" element={<FileCard />}></Route>
            <Route path="/Review" element={<ReviewComponent />}></Route>
            <Route path="/Submitted" element={<FinalCardComponent />}></Route>
            <Route
              path="/Status/:reimbursementId"
              element={<StatusCard />}
            ></Route>
            <Route path="*" element={<NoMatch />}></Route>
            <Route path="/feedbackForm" element={<FeedBacksForm />}></Route>
            <Route path="/about" element={<About />}></Route>
          </Routes>
        </MainContext.Provider>
      </main>
      <footer className="mt-1">
        <nav>
          <Link to="/">Home</Link> | <Link to="about">Help</Link> |{' '}
          <Link to="/feedbackForm">Feedback</Link>
        </nav>
        <div className="text-xs text-zinc-500">{version}</div>
        &copy; ACE Apps &middot; usaconservation.org &middot;{' '}
        {new Date().getFullYear()}
      </footer>
    </div>
  )
}

export default App
